import type { Money } from "@bioflow/contracts";

/** Копейки → «12 900 ₽» (или «12 900,50 ₽», если копейки ненулевые). */
export function formatMoney({ amountMinor, currency }: Money): string {
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: amountMinor % 100 === 0 ? 0 : 2,
  }).format(amountMinor / 100);
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/** «15 сентября» — для карточек статей, где год лишний. */
export function formatDateShort(iso: string): string {
  return new Date(iso).toLocaleDateString("ru-RU", { day: "numeric", month: "long" });
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Номер заказа для людей — как в ТЗ: №00001. */
export const formatOrderNumber = (orderNumber: string) => `№${orderNumber}`;
